import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectLiteSuggestionEntities, selectPremiumSuggestionEntities } from 'app/selectors/EntitiesSelector';

const getSuggestForPurchase = state => state.get('suggestForPurchase', Immutable.Map());

export const selectSuggestForPurchaseTransactions = createSelector([getSuggestForPurchase], suggestForPurchase =>
  suggestForPurchase.get('suggestForPurchaseTransactions', Immutable.Map())
);

export const selectLiteSuggestionsForCurrentUser = createSelector(
  [selectLiteSuggestionEntities, selectCurrentUser],
  (entities, currentUser) => {
    if (currentUser?.get('id')) {
      const suggestions = entities.find(entity => entity.get('ownerId') === currentUser.get('id'));
      return suggestions?.toList() || Immutable.List();
    }
    return Immutable.List();
  }
);

export const selectPremiumSuggestionsForCurrentUser = createSelector(
  [selectPremiumSuggestionEntities, selectCurrentUser],
  (entities, currentUser) => {
    if (currentUser?.get('id')) {
      const suggestions = entities.find(entity => entity.get('ownerId') === currentUser.get('id'));
      return suggestions?.toList() || Immutable.List();
    }
    return Immutable.List();
  }
);

export default {
  selectSuggestForPurchaseTransactions,
  selectLiteSuggestionsForCurrentUser,
  selectPremiumSuggestionsForCurrentUser
};
